<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function () {
  const paramsToRemove = [
    'shpxid',
    '_ab',
    '_fd',
    'pb',
    'sca_ref',
    'utm_source',
    'utm_medium',
    'utm_campaign'
  ];

  const url = new URL(window.location.href);
  let changed = false;

  paramsToRemove.forEach(p => {
    if (url.searchParams.has(p)) {
      url.searchParams.delete(p);
      changed = true;
    }
  });

  if (changed) {
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }
})();

